import t from "@/lang/lang";
import { MainPageContent } from "@/routes/_components/main-page";
import { useFeatureAuth } from "@/services/backend/auth/hooks/use-feature-auth";
import { Alert403 } from "@/shared/components/ui/alert-403";
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from "@/shared/components/ui/tabs";
import { useAuth } from "@/shared/lib/authorization/auth-context";
import { Role } from "@/shared/lib/authorization/roles";
import { useState } from "react";
import { CustomerStatsTable } from "./_components/customer-stats-table";
import { StatsOverviewTable } from "./_components/stats-overview-table";

export function StatsRoute() {
  const { user } = useAuth();
  const [role] = useState<Role>(user!.roles[0] as Role);
  const tabs = tabsForRole(role);

  const canAccess = useFeatureAuth("rosa.stats");
  if (!canAccess) {
    return (
      <MainPageContent>
        <Alert403 />
      </MainPageContent>
    );
  }

  return (
    <MainPageContent className="grid grid-cols-1 gap-6">
      <Tabs defaultValue={tabs[0]!.value}>
        <div className="flex">
          <TabsList>
            {tabs.map((tab) => (
              <TabsTrigger value={tab.value} key={tab.value}>
                {tab.label}
              </TabsTrigger>
            ))}
          </TabsList>
        </div>
        {tabs.some((tab) => tab.value === "customer-stats") && (
          <TabsContent value="customer-stats">
            <CustomerStatsTable />
          </TabsContent>
        )}
        {tabs.some((tab) => tab.value === "customer-overview") && (
          <TabsContent value="customer-overview">
            <StatsOverviewTable />
          </TabsContent>
        )}
      </Tabs>
    </MainPageContent>
  );
}

function tabsForRole(role: Role) {
  switch (role) {
    default:
      // For now, only the team leader has a different view
      // this may be modified at any time.
      return [
        { value: "customer-stats", label: t("Kundenstatistik") },
        { value: "customer-overview", label: t("Kundenübersicht") },
      ];
  }
}
